import { Injectable } from '@angular/core';
import { AppHttpClient } from '@app/shared/services/http.service';
import { Observable, ReplaySubject } from 'rxjs';
import { INotificationResponse } from '@app/modules/notifications/interface/notification';
import { ModelAttributes } from '@app/core/interface/common';

@Injectable()
export class NotificationsService {
  /**
   * @param http
   */
  constructor(private readonly http: AppHttpClient) {}

  public getNotification(
    currentPage: number = 1,
    itemsPerPage: number = 10,
    types: string[] = []
  ): Observable<INotificationResponse> {
    const result = new ReplaySubject<INotificationResponse>(1);
    let url = `notifications?page=${currentPage}&limit=${itemsPerPage}`;

    for (const type of types) {
      url += `&types=${type}`;
    }

    this.http.get(url).subscribe(
      (response: ModelAttributes) => {
        result.next({
          items: response.notifications,
          newNotificationCount: response.unviewedCount,
          pagination: {
            currentPage: response.currentPage,
            totalPages: response.totalPagesCount,
            totalItems: response.totalCount,
          },
          countByType: response.countByType,
        });
      },
      ({ error }) => result.error(error)
    );

    return result.asObservable();
  }

  public markAsRead(notificationIds: number[]): Observable<boolean> {
    const result = new ReplaySubject<boolean>(1);

    this.http.post('notifications/view', notificationIds).subscribe(
      () => result.next(true),
      ({ error }) => result.error(error)
    );

    return result.asObservable();
  }

  public markAsReadAll(): Observable<boolean> {
    const result = new ReplaySubject<boolean>(1);

    this.http.post('notifications/view-all', null).subscribe(
      () => result.next(true),
      ({ error }) => result.error(error)
    );

    return result.asObservable();
  }
}
